import { http } from '.';
import { CurrentSubscriptionResponse } from './fetchCurrentSubscription';

export interface UpdateCreditsRequest {
  email?: string;
  username?: string;
  imageCredits?: number;
  styleCredits?: number;
}

export interface UpdateCreditsResponse extends CurrentSubscriptionResponse {}

export async function updateUserCredits({
  email,
  username,
  imageCredits,
  styleCredits,
}: UpdateCreditsRequest): Promise<UpdateCreditsResponse> {
  console.log("📡 [Backend Call] Updating user credits:", {
    email,
    username,
    imageCredits,
    styleCredits,
  });

  const payload: any = {};
  
  if (email) {
    payload.email = email;
  }
  if (username) {
    payload.username = username;
  }
  if (imageCredits !== undefined) {
    payload.image_credits = imageCredits;
  }
  if (styleCredits !== undefined) {
    payload.style_credits = styleCredits;
  }

  const response = await http.post<UpdateCreditsResponse>('/subscriptions/update_credits/', payload);

  console.log("📡 [Backend Response] Update credits response:", response);
  return response;
}